import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

import NavBar from '../components/NavBar';
import FrTextInput from '../components/FrTextInput';
import UserOptions from '../components/UserOptions';
import FrSelect from '../components/FrSelect';
import FrLoading from '../components/FrLoading';

import api from '../services/api';
import { paramsToObject, dateSql, getUserCode, onlyNumbers } from '../utils/functions';
import { colors } from '../utils/vars';
import { mCPF, mVAL, mValidade, mTel, mCEP } from '../utils/masks'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import AutoComp from '../components/AutoComp'
import FrDatePicker from '../components/FrDatePicker'
import consultaCep from '../services/consultaCep'
import FrTableReg from '../components/FrTableReg'
import Dialog from '@material-ui/core/Dialog';
import { Icon } from 'react-icons-kit'
import { ic_search } from 'react-icons-kit/md/ic_search'
import Clientes from './Clientes'
import axios from 'axios';

const swal = withReactContent(Swal)
const moment = require("moment");

function Contratos(props) {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authsalute'] || JSON.stringify({ authenticated: false, user: 0, residente: 0 })));
  const [data, setData] = useState({ renova_automatico: 'S', dias: 0 })
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [comboCvn, setComboCvn] = useState([{ value: '', display: '' }])
  const [comboCam, setComboCam] = useState([{ value: '', display: '' }])
  const [comboSed, setComboSed] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [cli, setCli] = useState('')
  const [comboTco, setComboTco] = useState([{ value: '', display: '' }])
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])
  const [comboPrm, setComboPrm] = useState([{ value: '', display: '' }])
  const [dataDep, setDataDep] = useState([{ value: '', display: '', nome: '' }])
  const [dataCad, setDataCad] = useState('')
  const [mensalidadeAnterior, setMensalidadeAnterior] = useState('')
  const [dataCtr, setDataCtr] = useState([{ pk: 0, value: '', display: '', nome: '' }])
  const [comboOri, setComboOri] = useState([{ value: '', display: '' }])
  const [comboSub, setComboSub] = useState([{ value: '', display: '' }])
  const [nomeCli, setNomeCli] = useState('')
  const [pk_cli, setPk_Cli] = useState('')
  const [cto, setCto] = useState('')
  const [showModalCartao, setShowModalCartao] = useState(true)
  const [cartoes, setCartoes] = useState([])
  const [idCliPagarme, setIdCliPagarme] = useState()
  const [comboParcelas, setComboParcelas] = useState([{display: '', value: ''}])
  const [comboRep, setComboRep] = useState([{display: '', value: ''}])
  const [mostraComboParcelas, setMostraComboParcelas] = useState(false)

  const columnsDep = [{ id: 'nome', numeric: false, label: 'Nome', align: 'left', minWidth: 200 },
    { id: 'cpf', numeric: false, label: 'CPF', align: 'left', minWidth: 90 },
    { id: 'nomegrp', numeric: false, label: 'Grau Parentesco', align: 'left', minWidth: 100 },
    { id: 'sexo', numeric: false, label: 'Sexo', align: 'left', minWidth: 50 },
    { id: 'data_nascimento', date: true, numeric: false, label: 'Data Nascimento', align: 'left', minWidth: 100 },
    { id: 'recebeu_carteira', numeric: false, label: 'Recebeu Carteira', align: 'center', minWidth: 50 },
    { id: 'data_cadastro', date: true, numeric: false, label: 'Data Cadastro', align: 'left', minWidth: 100 },
    { id: 'data_cancelado', date: true, numeric: false, label: 'Data Cancelado', align: 'left', minWidth: 100 },
    { id: 'representante', numeric: false, label: 'Representante', align: 'left', minWidth: 200 },
  ]

  const columnsCtr = [{ id: 'parcela', numeric: false, label: 'Parcela', align: 'center', minWidth: 50 },
    { id: 'data_venc', date: true, numeric: false, label: 'Vencimento', align: 'left', minWidth: 100 },
    { id: 'valor', moeda: true, numeric: false, label: 'Valor', align: 'left', minWidth: 200 },
    { id: 'promocao', numeric: false, label: 'Promoção', align: 'left', minWidth: 200 },
    { id: 'justificativa_promocao',  numeric: false, label: 'Justificativa Promo', align: 'left', minWidth: 200 },
  ]

  const [showModal, setShowModal] = useState(false)
  const [titulo, setTitulo] = useState('')
  const [updateDep, setUpdateDep] = useState(false)
  const [dep, setDep] = useState('')
  const [nome, setNome] = useState('')
  const [cpf, setCpf] = useState('')
  const [sexo, setSexo] = useState('')
  const [data_nascimento, setData_Nascimento] = useState('')
  const [representante, setRepresentante] = useState('')
  const [fk_rep, setFk_rep] = useState('')
  const [comboGrp, setComboGrp] = useState([{ value: '', display: '' }])
  const [fk_grp, setFk_Grp] = useState('')
  const [recebeu_carteira, setRecebeu_Carteira] = useState('')
  const [pkModal, setPkModal] = useState(0);
  const [nomegrp, setNomeGrp] = useState('')

  const [valor, setValor] = useState('')
  const [data_venc, setVencimento] = useState('')
  const [showModalCtr, setShowModalCtr] = useState(false)

  const [showModalCliente, setShowModalCliente] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      let codigo = props.pk_cto ? props.pk_cto : query.codigo

      


      if (codigo > 0) {
        setEnableEdit(await api.getAcessos('Contratos', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Contratos', 'Inclusao'))
      }

      setComboOri(await api.getComboData('origens_contatos'))
      setComboPrm(await api.getComboData('promocoes'))
      setComboSub(await api.getComboData('sub_origem'))
      setComboCvn(await api.getComboData('convenios'))
      setComboCam(await api.getComboData('campanhas'))
      setComboRep(await api.getComboData('representantes'))
      setComboSed(await api.getComboDataWhere('sedes', "?fk_usu=" + getUserCode()))

      setComboTco(await api.getComboData('tipo_contrato'))
      setComboCid(await api.getComboData('cidades'))
      setComboGrp(await api.getComboData('grau_parentesco'))

      if (codigo > 0) {
        setUpdateType(true)
        api.get('/contratos?pk_cto=' + codigo).then(async r => {
          if (r.data[0]) {
            setComboCli(await api.getComboDataWhere('clientes', "?nome=" + r.data[0].nomecli))
            setMensalidadeAnterior(r.data[0].mensalidade)
            if (r.data[0].mensalidade) {
              let valorFinal = r.data[0].mensalidade

              setMensalidadeAnterior(mVAL(r.data[0].mensalidade * 100))
              r.data[0].mensalidade = mVAL(r.data[0].mensalidade * 100)

              let desconto = 0

              if (r.data[0].desconto_cliente > 0)
                desconto = Number(r.data[0].desconto_cliente)

              if (r.data[0].desconto_sede > 0)
                desconto = desconto + Number(r.data[0].desconto_sede)

              if (r.data[0].desconto_outros > 0)
                desconto = desconto + Number(r.data[0].desconto_outros)


              valorFinal = valorFinal * ((100 - desconto) / 100)
              r.data[0].valor_final = mVAL(valorFinal * 100)

            }
            setData(r.data[0])
            api.get('/contratos/dependentes?pk_cto=' + codigo).then(r => {
              if (r.data.length > 0)
                setDataDep(r.data)

              api.get('/contratos/ctr?pk_cto=' + codigo).then(r => {
                if (r.data.length > 0)
                  setDataCtr(r.data)

                swal.close()
              })
            })
          } else {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },
              title: 'Código Inválido!',
              text: "Código não encontrado!",
              icon: 'warning',
            }).then((result) => {
              if (result.value) {
                if (props.modal)
                  props.setShowModal(false)
                else
                  window.history.back()
              }
            })
          }
        })
      } else {
        let auxValues = {...data}
        
        if (query.fk_cli) {
          auxValues.fk_cli = query.fk_cli
          api.get('/clientes?pk_cli=' + query.fk_cli).then(async r => {
            setNomeCli(r.data[0].nome)
            setComboCli(await api.getComboDataWhere('clientes', "?nome=" + r.data[0].nome))
            setCli(query.fk_cli)
            
            // setData(auxValues)
          })
        }
        
        auxValues.data_inicio = new Date()
        auxValues.data_inicio = moment(auxValues.data_inicio).format("YYYY-MM-DD")
        let data_fim = new Date(auxValues.data_inicio)
        data_fim = moment(data_fim).add(365, 'days').format("YYYY-MM-DD");
        auxValues.data_fim = data_fim
        auxValues.fk_sed = (auth.pk_sed ? auth.pk_sed : '')
        setData(auxValues)
        swal.close()
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const calculaMensalidade = async () => {
      if (data.fk_tco > 0) {
        const auxValues = { ...data };
        // auxValues.mensalidade = 0
        await api.get('/tipo_contrato?pk_tco=' + data.fk_tco).then(async r => {
          if (r.data[0]) {
            setComboFpg(await api.getComboDataWhere('formas_pagamento', "?fk_tpf=" + r.data[0].fk_tpf))
            auxValues.fk_tpf = r.data[0].fk_tpf
          }
        })

        const deps = dataDep.filter(item => {
          return item.data_cancelado == null && item.nome != ''
        })

        await api.get('/tabela_precos?fk_tco=' + data.fk_tco + '&qtd_deps=' + deps.length).then(r => {
          if (r.data[0]) {
            auxValues.mensalidade = mVAL(r.data[0].valor * 100)
            let valorFinal = Number(r.data[0].valor)
            // console.log(r.data[0])

            let desconto = 0

            if (r.data[0].desconto_cliente > 0)
              desconto = Number(r.data[0].desconto_cliente)

            if (r.data[0].desconto_sede > 0)
              desconto = desconto + Number(r.data[0].desconto_sede)

            if (r.data[0].desconto_outros > 0)
              desconto = desconto + Number(r.data[0].desconto_outros)


            
            valorFinal = Math.round(valorFinal * ((100 - desconto)))


            auxValues.valor_final = mVAL(valorFinal)

            setData(auxValues)
          } else
            setData(auxValues)
        })
      }
    }
    calculaMensalidade()
  }, [dataDep, data.fk_tco])


  useEffect(() => {
    const calculaMensalidade = async () => {

      const auxValues = { ...data };

      let value = data.mensalidade

      try {
        value = data.mensalidade.replace(".", "").replace(",", ".")
      } catch (error) {
        value = data.mensalidade
      }

      let valorFinal = Number(value)
      let desconto = 0

      if (data.desconto_cliente > 0)
        desconto = Number(data.desconto_cliente)

      if (data.desconto_sede > 0)
        desconto = desconto + Number(data.desconto_sede)

      if (data.desconto_outros > 0)
        desconto = desconto + Number(data.desconto_outros)


      valorFinal = Math.round(valorFinal * ((100 - desconto)))


      auxValues.valor_final = mVAL(valorFinal)
      

      setData(auxValues)
    }
    calculaMensalidade()
  }, [data.mensalidade, data.desconto_cliente, data.desconto_outros, data.desconto_sede])

  useEffect(() => {
    const atualizaCombo = () => {
      // alert('contratos pk_cli:' + pk_cli)
      if (nomeCli != '')
        setNome(nomeCli)
      if (pk_cli > 0)
        setDep(pk_cli)
    }
    atualizaCombo()
  }, [nomeCli, pk_cli])


  async function consistData(data) {
    let required = [
      'fk_cli',
      'cpf',
      'sexo',
      'data_nascimento',
      'fk_ori',
      'data_inicio',
      'data_fim',
      'fk_sed',
      'fk_tco',
      'mensalidade',
      'fk_fpg',
      'dia_venc'
    ]

    if (data.fk_tco == 7) {
      required = [
        'fk_cli',
        'cpf',
        'sexo',
        'fk_ori',
        'data_nascimento',
        'data_inicio',
        'data_fim',
        'fk_sed',
        'fk_tco',
        'pn',
        'uc',
        'mensalidade',
        'fk_fpg',
        'dia_venc'
      ]
    }
    if (data.fk_prm){
      let obrigaJustificativa = await api.get('promocoes?pk_prm='+ data.fk_prm)
      console.log(obrigaJustificativa)
      if (obrigaJustificativa.data[0].exige_justificativa == 'S')
        required.push('justificativa_promocao')

    }

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr == 'fk_cli')
        fieldName = 'Titular'

      if (curr == 'fk_tco')
        fieldName = 'Tipo'

      if (curr == 'data_inicio')
        fieldName = 'Data Início'

      if (curr == 'data_nascimento')
        fieldName = 'Data Nascimento'
      
      if (curr == 'fk_ori')
        fieldName = 'Origem'

      if (curr == 'data_fim')
        fieldName = 'Data Fim'

      if (curr == 'fk_fpg')
        fieldName = 'Forma de Pagamento'

      if (curr == 'dia_venc')
        fieldName = 'Dia Vcto'

      if (curr == 'fk_sed')
        fieldName = 'Sede'

      if (curr == 'justificativa_promocao')
        fieldName = 'Justificativa Promo'

      if (!data[curr]) return errors.push(fieldName)
    })

    if (dataCtr[0].pk == 0) errors.push('Parcelas')

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      title: 'ATENÇÃO',
      text: "Confirma geração do contrato?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.data_venc_cartao = dateSql('01/' + auxValues.venc_cartao)
        auxValues.dataDep = dataDep
        auxValues.dataCtr = dataCtr
        auxValues.fk_usu = getUserCode()
        auxValues.mudouValor = mensalidadeAnterior !== data.mensalidade
        let errors = await consistData(auxValues)
        if (errors.length === 0) {
          
          salvarContrato()
        } else {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function salvarContrato() {
    const auxValues = { ...data };
    auxValues.data_venc_cartao = dateSql('01/' + auxValues.venc_cartao)
    auxValues.dataDep = dataDep
    auxValues.fk_usu = getUserCode()
    auxValues.mudouValor = mensalidadeAnterior !== data.mensalidade
    auxValues.dataCtr = dataCtr

    if (updateType) {
      api.post('/contratos/edit', auxValues).then(r => {
        if (r.status === 200) {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: 'Registro Alterado',
            text: "O registro foi alterado com sucesso!",
            icon: 'success',
          }).then((result) => {
            if (result.value) {
              if (props.modal)
                props.setShowModal(false)
              else
                window.location.href = '/salute/contratos?buscar=true&pk_cto=' + auxValues.pk_cto
            }
          })
        } else {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: 'Erro!',
            text: "O registro não foi alterado!",
            icon: 'warning',
          })
        }
      })
    } else {
      api.post('/contratos/add', auxValues).then(r => {
        if (r.status === 200) {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: 'Registro Adicionado',
            text: "O registro foi adicionado com sucesso!",
            icon: 'success',
          }).then((result) => {
            if (result.value) {
              if (props.modal)
                props.setShowModal(false)
              else
                processoPagamento(r.data)
              //   window.location.href = '/salute/contratos?buscar=true&pk_cto=' + r.data
            }
          })
        } else {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: 'Erro!',
            text: "O registro não foi adicionado!",
            icon: 'warning',
          })
        }
      })
    }
  }


  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        if (props.modal)
          props.setShowModal(false)
        else
          window.history.back()
      }
    })
  }


  useEffect(() => {
    const fetchData = async () => {
      const auxValues = { ...data };
      auxValues.fk_cli = cli
      
      if (cli > 0) {
        await api.get('/clientes?pk_cli=' + cli).then(async r => {
          if (r.data[0]) {
            auxValues.cpf = r.data[0].cpf
            auxValues.data_nascimento = r.data[0].data_nascimento
            auxValues.sexo = r.data[0].genero
            auxValues.fk_ori = r.data[0].fk_ori
            auxValues.fk_sub = r.data[0].fk_sub
            auxValues.nome = r.data[0].nome
            // alert(auxValues.nome)
            setData(auxValues)
            await api.get('/clientes/sincronizaClientePagarme?pk_cli='+cli).then (res => {
              console.log(res)
              setIdCliPagarme(res)
            })
            if (!updateType){
              console.log("/contratos?cpf=" + r.data[0].cpf +
              '&fk_sct=2')
              api.get("/contratos?cpf=" + r.data[0].cpf +
              '&fk_sct=2').then(res => {
                console.log(res.data[0])
                if ((res.data[0]))
                  swal.fire({
                    customClass: {
                      container: 'my-swal'
                    },
                    title: 'Erro!',
                    text: "Já existe contrato ativo para este CPF!",
                    icon: 'warning',
                  }).then(() => {
                    document.getElementById('fk_cli').focus()
                  })
              })
            }
          }
        })
      } else
        setData(auxValues)
    }

    fetchData()
  }, [cli])

  function blurCiente(e) {
    if (!updateType && cli > 0 && data.cpf){
      console.log("/contratos?cpf=" + data.cpf +
      '&fk_sct=2')
      api.get("/contratos?cpf=" + data.cpf +
      '&fk_sct=2').then(res => {
        console.log(res.data[0])
        if ((res.data[0]))
          swal.fire({
            customClass: {
              container: 'my-swal'
            },
            title: 'Erro!',
            text: "Já existe contrato ativo para este CPF!",
            icon: 'warning',
          }).then(() => {
            document.getElementById('fk_cli').focus()
          })
        
      })
    }
  }

  useEffect(() => {
    const fetchData = async () => {

      if (dep > 0) {
        await api.get('/clientes?pk_cli=' + dep).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            setNome(r.data[0].nome)
            setCpf(r.data[0].cpf)
            setSexo(r.data[0].genero)
            setData_Nascimento(r.data[0].data_nascimento)
            setRepresentante(r.data[0].nomerep)
            setFk_rep(r.data[0].fk_rep)
          }
        })
      }
    }

    fetchData()
  }, [dep])

  useEffect(() => {
    const fetchData = () => {
      if (fk_grp > 0) {
        api.get('/grau_parentesco?pk_grp=' + fk_grp).then(r => {
          if (r.data[0]) {
            setNomeGrp(r.data[0].descricao)
          }
        })
      }
    }

    fetchData()
  }, [fk_grp])

  function processoPagamento(pk_cto){
    let periodo = ''
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Gerando dados pagamento..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('tipo_contrato?pk_tco='+data.fk_tco).then(async r=>{
      periodo = r.data[0].frequencia_pagamento == 'M' ? 'mensal' : 'anual'
      

      let ctrs = await api.get('contas_receber?pk_cto='+pk_cto)
      let valorCobranca = periodo == 'mensal' ? dataCtr[0].valor : dataCtr.reduce((accumulator, currentValue) => accumulator + currentValue.valor, 0)
      let parcelas = periodo == 'mensal' ? String(ctrs.data[0].pk_ctr) : ctrs.data.reduce((accumulator, currentValue) => accumulator + String(currentValue.pk_ctr) + ',', 0)

      if (parcelas.toString().indexOf(',') > 0){
        parcelas = parcelas.slice(0, -1)
      }

      let dadosPagamento = {
        pk_cli: data.fk_cli,
        parcelas: parcelas,
        total: valorCobranca,
        pk_cto: pk_cto      
      }
      
      let fpg = await api.get('/formas_pagamento?pk_fpg=' + data.fk_fpg)
      
      if (fpg.data[0].fk_tpf == 1) {
        pagamentoCartao(dadosPagamento)
      } else {
        pagamentoPix(dadosPagamento)
      }
    })
  }

  useEffect(() => {
    function calculaParcelas() {

      if (data.fk_tco && data.fk_fpg) {
        let valFinal = 0
        let dataIni = moment(new Date()).format("YYYY-MM-DD")
        let dataFim = moment(dataIni).add(10, "month").format("YYYY-MM-" + data.dia_venc)
        let pk = 1
        let item = []
        let parcela = 1

        let value = 0
        try {
          value = data.valor_final.replace(".", "").replace(",", ".")
        } catch (error) {
          value = data.valor_final
        }

        let valorFinal = Number(value)

        let desconto = 0

        if (data.desconto_cliente > 0)
          desconto = Number(data.desconto_cliente)

        if (data.desconto_sede > 0)
          desconto = desconto + Number(data.desconto_sede)

        if (data.desconto_outros > 0)
          desconto = desconto + Number(data.desconto_outros)

        
          valorFinal = Math.round(valorFinal * ((100 - desconto)))
          valorFinal = valorFinal/100

          valFinal = valFinal + valorFinal

      
        while (pk < 12) {

          dataIni = moment(dataIni).add(1, "month").format("YYYY-MM-" + data.dia_venc);
          pk++
          parcela++

          valorFinal = Number(value)

          let desconto = 0

          if ((data.desconto_cliente > 0) && (parcela <= data.qtd_desconto_cliente))
            desconto = Number(data.desconto_cliente)

          if ((data.desconto_sede > 0) && (parcela <= data.qtd_desconto_sede))
            desconto = desconto + Number(data.desconto_sede)

          if ((data.desconto_outros > 0) && (parcela <= data.qtd_desconto_outros))
            desconto = desconto + Number(data.desconto_outros)


          valorFinal = Math.round(valorFinal * ((100 - desconto)))
          valorFinal = valorFinal/100


          valFinal = valFinal + valorFinal

          
        }


        console.log(dataCtr[0].valor)
        api.get('tipo_contrato?pk_tco='+ data.fk_tco).then((r) => {
          api.get('formas_pagamento?pk_fpg='+data.fk_fpg).then(res => {
            if (res.data[0].fk_tpf == 1 && r.data[0].frequencia_pagamento == 'A') {
              console.log(valFinal*100)
              let auxVal = valFinal*100
              setMostraComboParcelas(true)
              console.log(auxVal)
              setComboParcelas([
                {value: '1', display: 'A vista - 1 x '+ mVAL(auxVal)},
                {value: '2', display: 'Parcelado em 2 x R$ '+ mVAL(Math.round(auxVal / 2 )) + ' s/juros'},
                {value: '3', display: 'Parcelado em 3 x R$ '+ mVAL(Math.round(auxVal / 3 )) + ' s/juros'},
                {value: '4', display: 'Parcelado em 4 x R$ '+ mVAL(Math.round(auxVal / 4 )) + ' s/juros'},
                {value: '5', display: 'Parcelado em 5 x R$ '+ mVAL(Math.round(auxVal / 5 )) + ' s/juros'},
                {value: '6', display: 'Parcelado em 6 x R$ '+ mVAL(Math.round(auxVal / 6 )) + ' s/juros'},
                {value: '7', display: 'Parcelado em 7 x R$ '+ mVAL(Math.round(auxVal / 7 )) + ' s/juros'},
                {value: '8', display: 'Parcelado em 8 x R$ '+ mVAL(Math.round(auxVal / 8 )) + ' s/juros'},
                {value: '9', display: 'Parcelado em 9 x R$ '+ mVAL(Math.round(auxVal / 9 )) + ' s/juros'},
                {value: '10', display: 'Parcelado em 10 x R$ '+ mVAL(Math.round(auxVal / 10 )) + ' s/juros'},
                {value: '11', display: 'Parcelado em 11 x R$ '+ mVAL(Math.round(auxVal / 11 )) + ' s/juros'},
                {value: '12', display: 'Parcelado em 12 x R$ '+ mVAL(Math.round(auxVal / 12 )) + ' s/juros'},
              ])
            } else {
              setMostraComboParcelas(false)
            }
          })
        })
      }    
    }

    calculaParcelas()

  }, [data.fk_fpg, data.fk_tco, data.valor_final, data.qtd_desconto_cliente, data.qtd_desconto_outros, data.qtd_desconto_sede])

  useEffect(() => {
    if (data.parcelas > 0){
      let auxValues = {...data}
      auxValues.valor = Math.round(auxValues.mensalidade.replace(',','').replace('.','').replace('.',''))
      auxValues.valor = Math.round((auxValues.valor * 12) / data.parcelas)
      auxValues.valor = mVAL(auxValues.valor)
      // auxValues.valor_final = auxValues.valor

      setData(auxValues)
    }
  }, [data.parcelas, data.mensalidade])

  async function copiaLink (link) {
    await navigator.clipboard.writeText(link)
    swal.close()
  }

  function abreLink (link) {
    swal.close()
    window.open(link, '_blank').focus()
  }

  function pagamentoCartao(dadosPagamento) {
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: 
        <div>
          <h3>
            Link para pagamento:
          </h3>
          <p>
          {window.location.origin+'/salute/pagamento_adesao?id='+dadosPagamento.pk_cto}
          </p>
          <button className="botao" onClick={() => abreLink(window.location.origin+'/salute/pagamento_adesao?id='+dadosPagamento.pk_cto)}>
              Abrir
          </button>
          <button className="botao" onClick={() => copiaLink(window.location.origin+'/salute/pagamento_adesao?id='+dadosPagamento.pk_cto)}>
            Copiar
          </button>
        </div>,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    
  }

  function pagamentoPix(dadosPagamento) {
    api.post('pagarMe/pix?pk_cli='+data.fk_cli, dadosPagamento).then(r=>{
      console.log(r.data)
      swal.fire({
        customClass: {
          container: 'my-swal'
        },
        html: 
          <div>
            <h3>
              Código PIX Gerado:
            </h3>
            <p>
              {r.data.pix_qrcode}
            </p>
            <button className="botao" onClick={() => copiaLink(r.data.pix_qrcode)} style={{marginBottom: 6}}>
              Copiar
            </button>
            <button className="botao" onClick={() => swal.fire()}>
              Continuar
            </button>
          </div>,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      // swal.fire("Código PIX Gerado:", r.data.pix_qrcode, 'success').then (res =>{
      //   window.location.href = '/salute/contratos?buscar=true&pk_cto=' + dadosPagamento.pk_cto
      // })
    })
  }

  const handleChange = async (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'fk_cli':
        setCli(e.target.value);
        await api.get('/clientes?pk_cli=' + e.target.value).then(r => {
          if (r.data[0]) {

            auxValues.cpf = r.data[0].cpf
            auxValues.data_nascimento = r.data[0].data_nascimento
            auxValues.sexo = r.data[0].genero
            auxValues.nome = r.data[0].nome
          }
        })
        break

      case 'mensalidade':
        auxValues[e.target.name] = e.target.value ? mVAL(e.target.value, 2) : '';

        break;

      case 'recebeu_carteira':
        auxValues.recebeu_carteira = auxValues.recebeu_carteira == 'S' ? 'N' : 'S'
        break

      case 'renova_automatico':
        auxValues.renova_automatico = auxValues.renova_automatico == 'S' ? 'N' : 'S'
        break

      case 'dep_recebeu_carteira':
        setRecebeu_Carteira(recebeu_carteira == 'S' ? 'N' : 'S')
        break

      case 'fk_rep':
        setFk_rep(e.target.value)
        break

      case 'fk_grp':
        setFk_Grp(e.target.value)
        break

      case 'representante':
        setRepresentante(e.target.value)
        break

      case 'valor':
        setValor(e.target.value ? mVAL(e.target.value) : '');
        break

      case 'data_venc':
        setVencimento(e.target.value)
        break

      case 'data_inicio':
        auxValues[e.target.name] = e.target.value;
        let data_fim = new Date(auxValues.data_inicio)
        data_fim = moment(data_fim).add(365, 'days').format("YYYY-MM-DD");
        auxValues.data_fim = data_fim
        break

      case 'fk_tco':
        auxValues[e.target.name] = e.target.value;

        break

      case 'fk_prm': 
        auxValues[e.target.name] = e.target.value;
        auxValues.desconto_outros = 0
        console.log()
        if (e.target.value){
          let prm = await api.get('/promocoes?pk_prm='+e.target.value)
          if (prm.data[0].desconto) {
              auxValues.desconto_outros = (prm.data[0].desconto.replace('.', ','))
          }
        }
        break;

      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  const handleCep = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    consultaCep((e.target.value).replace('.', '').replace('-', '') + '/json').then(r => {
      if (!r.data.erro) {
        auxValues.endereco_titular_conta = r.data.logradouro
        api.get('/cidades?descricao=' + r.data.localidade).then(res => {
          if (res.data.length > 0) {
            auxValues.fk_cid_titular_conta = res.data[0].pk_cid
          }
          setData(auxValues)
          swal.close()
        })
      } else {
        swal.close()
        swal.fire({
          customClass: {
            container: 'my-swal'
          },
          title: 'CEP Inválido!',
          text: "CEP Não encontrado nos registros!",
          icon: 'warning',
        })
      }
    })
  }


  const pegaDadosTitular = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/clientes?pk_cli=' + data.fk_cli).then(res => {
      auxValues.cep_titular_conta = res.data[0].cep
      auxValues.endereco_titular_conta = res.data[0].endereco
      auxValues.fk_cid_titular_conta = res.data[0].fk_cid
      auxValues.fone_titular_conta = res.data[0].fone1
      auxValues.nome_titular_conta = res.data[0].nome
      auxValues.cpf_titular_conta = res.data[0].cpf

      setData(auxValues)
      swal.close()
    })
  }

  const pegaDadosResponsavel = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      customClass: {
        container: 'my-swal'
      },
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/clientes?pk_cli=' + data.fk_cli).then(res => {
      console.log(res.data[0])
      auxValues.cep_titular_conta = res.data[0].cep_responsavel
      auxValues.endereco_titular_conta = res.data[0].endereco_responsavel
      auxValues.fk_cid_titular_conta = res.data[0].fk_cid_responsavel
      auxValues.fone_titular_conta = res.data[0].fone1_responsavel
      auxValues.nome_titular_conta = res.data[0].nome_responsavel
      auxValues.cpf_titular_conta = res.data[0].cpf_responsavel
      setData(auxValues)
      swal.close()
      
    })
  }

  function incluiDep(e) {
    e.preventDefault();
    const dataAtual = new Date();
    const dataFormatada = moment(dataAtual).format('YYYY-MM-DD')

    setTitulo('Inclusão de Dependente')
    setUpdateDep(false)
    setCpf('')
    setSexo('')
    setData_Nascimento('')
    setFk_Grp('')
    setNomeGrp('')
    setRecebeu_Carteira('N')
    setDep('')
    setDataCad(dataFormatada)
    setNome('')
    setRepresentante('')
    setShowModal(true)
  }

  function confirmaDep(e) {
    e.preventDefault();
    if (updateDep)
      editaDep(e)
    else
      insereDep(e)

    setUpdateDep(false)
    setShowModal(false)
  }

  function confirmaCtr(e) {
    e.preventDefault();

    let item = [];
    let i;
    for (i = 0; i < dataCtr.length; i++) {
      if (dataCtr[i].pk == pkModal) {
        item.push({
          pk: pkModal,
          data_venc: data_venc,
          fk_fpg: data.fk_fpg,
          valor: valor
        });

      } else {
        item.push({
          pk: dataCtr[i].pk,
          data_venc: dataCtr[i].data_venc,
          fk_fpg: dataCtr[i].fk_fpg,
          valor: dataCtr[i].valor
        });
      }

      if (i + 1 == dataCtr.length) setDataCtr(item);
    }
    setShowModalCtr(false)
  }

  function gerarParcelas(e) {
    e.preventDefault();
    if ((!data.dia_venc) || (data.dia_venc == 0) || (!data.fk_fpg)) {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },
        title: 'Erro!',
        text: "Forma de pagamento e dia de vencimento devem ser informados!",
        icon: 'warning',
      })

    } else {
      let dataIni = moment(new Date()).format("YYYY-MM-DD")
      let dataFim = moment(dataIni).add(10, "month").format("YYYY-MM-" + data.dia_venc)
      let pk = 1
      let item = []
      let parcela = 1

      let value = 0
      try {
        value = data.mensalidade.replace(".", "").replace(",", ".")
      } catch (error) {
        value = data.mensalidade
      }

      let valorFinal = Number(value)

      let desconto = 0

      if (data.desconto_cliente > 0)
        desconto = Number(data.desconto_cliente)

      if (data.desconto_sede > 0)
        desconto = desconto + Number(data.desconto_sede)

      if (data.desconto_outros > 0)
        desconto = desconto + Number(data.desconto_outros)

      
        valorFinal = Math.round(valorFinal * ((100 - desconto)))
        valorFinal = valorFinal/100

      item.push(
        {
          pk: pk,
          fk_fpg: data.fk_fpg,
          parcela: parcela,
          data_venc: dataIni,
          valor: valorFinal,
          fk_prm: data.fk_prm,
          promocao: data.fk_prm ? comboPrm.filter(item => item.value == data.fk_prm)[0].display : '',
          justificativa_promocao: data.justificativa_promocao
        }
      );

     
      while (pk < 12) {

        dataIni = moment(dataIni).add(1, "month").format("YYYY-MM-" + data.dia_venc);
        pk++
        parcela++

        valorFinal = Number(value)

        let desconto = 0

        if ((data.desconto_cliente > 0) && (parcela <= data.qtd_desconto_cliente))
          desconto = Number(data.desconto_cliente)

        if ((data.desconto_sede > 0) && (parcela <= data.qtd_desconto_sede))
          desconto = desconto + Number(data.desconto_sede)

        if ((data.desconto_outros > 0) && (parcela <= data.qtd_desconto_outros))
          desconto = desconto + Number(data.desconto_outros)


        valorFinal = Math.round(valorFinal * ((100 - desconto)))
        valorFinal = valorFinal/100


        item.push(
          {
            pk: pk,
            fk_fpg: data.fk_fpg,
            parcela: parcela,
            data_venc: dataIni,
            valor: valorFinal,
            fk_prm: desconto > 0 ? data.fk_prm : '',
            promocao: data.fk_prm > 0 ? comboPrm.filter(item => item.value == data.fk_prm)[0].display : '',
            justificativa_promocao: desconto > 0 ? data.justificativa_promocao : ''
          });

        if (pk == 12){
          setDataCtr(item)
        }

      }
    }
  }

  function escondeModal(e) {
    e.preventDefault();
    setShowModal(false)
  }


  function escondeModalCtr(e) {
    e.preventDefault();
    setShowModalCtr(false)
  }


  function mostraModalCliente(e) {
    e.preventDefault();
    setShowModalCliente(true)
  }

  function insereItem() {
    let pk = dataDep[0].pk ? dataDep.length + 1 : 1
    let item = []

    item.push(
      {
        dep: dep,
        nome: nome,
        cpf: cpf,
        sexo: sexo,
        data_nascimento: data_nascimento,
        representante: representante,
        fk_grp: fk_grp,
        recebeu_carteira: recebeu_carteira,
        nomegrp: nomegrp,
        data_cadastro: dataCad,
        pk: pk
      });

    return item;
  }

  function insereDep(e) {
    e.preventDefault();
    let item = insereItem()
    console.log(dataDep)
    for (var i = 0; i < dataDep.length; i++) {
      if (dataDep[i].nome !== '')
        item.push({
          dep: dataDep[i].dep,
          nome: dataDep[i].nome,
          cpf: dataDep[i].cpf,
          sexo: dataDep[i].sexo,
          data_nascimento: dataDep[i].data_nascimento,
          representante: dataDep[i].representante,
          fk_grp: dataDep[i].fk_grp,
          recebeu_carteira: dataDep[i].recebeu_carteira,
          pk: dataDep[i].pk,
          nomegrp: dataDep[i].nomegrp,
          data_cadastro: dataDep[i].data_cadastro,
          fk_mot: dataDep[i].fk_mot,
          nomemot: dataDep[i].nomemot,
          data_cancelado: dataDep[i].data_cancelado


        });
    }
    setDataDep(item);
  }


  function editaDep(e) {
    e.preventDefault();

    let item = [];
    let i;
    console.log(dataDep)
    for (i = 0; i < dataDep.length; i++) {
      if (dataDep[i].pk == pkModal) {
        item.push({
          dep: dep,
          nome: nome,
          cpf: cpf,
          sexo: sexo,
          data_nascimento: data_nascimento,
          representante: representante,
          fk_grp: fk_grp,
          recebeu_carteira: recebeu_carteira,
          nomegrp: nomegrp,
          data_cadastro: dataCad,
          pk: pkModal
        });

      } else {
        item.push({
          dep: dataDep[i].dep,
          nome: dataDep[i].nome,
          cpf: dataDep[i].cpf,
          sexo: dataDep[i].sexo,
          data_nascimento: dataDep[i].data_nascimento,
          representante: dataDep[i].representante,
          fk_grp: dataDep[i].fk_grp,
          recebeu_carteira: dataDep[i].recebeu_carteira,
          pk: dataDep[i].pk,
          formatData: dataDep[i].formatData,
          nomegrp: dataDep[i].nomegrp,
          data_cadastro: dataDep[i].data_cadastro,
          fk_mot: dataDep[i].fk_mot,
          nomemot: dataDep[i].nomemot,
          data_cancelado: dataDep[i].data_cancelado
        });
      }

      if (i + 1 == dataDep.length) setDataDep(item);
    }
  }


  function mostraModalCliente(e) {
    e.preventDefault()
    setShowModalCliente(true)
  }

  function salvaCartao(e) {
    if (data.fk_tpf != 1 || 
        !data.numero_cartao || 
        !data.cod_seguranca_cartao || 
        !data.venc_cartao || 
        !data.vencimento_fatura_cartao ||
        !data.titular_cartao ||
        !data.cpf_titular_cartao ||
        !data.fone_titular_cartao
    ){
      return swal.fire('Campos inválidos.', 'Preencha todos os dados do cartão', '')
    }

    api.post('pagarMe/salva_cartao?pk_cli=' + data.fk_cli, data).then(r => {
      console.log(r)
      swal.fire(r.data.header, r.data.mensagem, r.data.status)

    })
  }

  return (
    <div className="defaultReg">

      {!props.modal ? <NavBar /> : <></>}

      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Contrato</h3>
          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          {!updateType ?
            <AutoComp
              value={data.nome || ""}
              valor={cli}
              width={425}
              name="fk_cli"
              id="fk_cli"
              label='Titular'
              data={comboCli}
              setValue={setCli}
              tabela={'clientes'}
              chave={'nome'}
              autoFocus
              onBlur={blurCiente}
            />
            :
            <FrSelect
              value={data.fk_cli || ''}
              onChange={handleChange}
              name="fk_cli"
              id="fk_cli"
              label='Titular'
              data={comboCli}
              style={{ width: 425 }}
              disabled
            />
          }

          <FrTextInput
            value={mCPF(data.cpf) || ''}
            style={{ width: 130 }}
            color="#333333"
            label="CPF"
            variant="outlined"
            size="small"
            disabled
          />

          <FrTextInput
            value={data.sexo || ''}
            style={{ width: 100 }}
            color="#333333"
            label="Sexo"
            variant="outlined"
            size="small"
            disabled
          />
          <FrDatePicker
            value={(data.data_nascimento || '').split('T')[0]}
            color="#49573B"
            label="Dt.Nascimento"
            variant="outlined"
            size="small"
            style={{ width: 130 }}
            noClear
            disabled
          />
          <FrSelect
            value={data.fk_ori || ''}
            onChange={handleChange}
            name="fk_ori"
            id="fk_ori"
            label='Origem Contato'
            data={comboOri}
            style={{ width: 200 }}
            disabled
          />

          <FrSelect
            value={data.fk_sub || ''}
            onChange={handleChange}
            name="fk_sub"
            id="fk_sub"
            label='SubOrigem Contato'
            data={comboSub}
            style={{ width: 200 }}
            disabled
          />


          <br />
          <FrDatePicker
            value={(data.data_inicio || '').split('T')[0]}
            name="data_inicio"
            id="data_inicio"
            color="#49573B"
            label="Início Contrato"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            onChange={handleChange}
          />

          <FrDatePicker
            value={(data.data_fim || '').split('T')[0]}
            name="data_fim"
            id="data_fim"
            color="#49573B"
            label="Final Contrato"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
            onChange={handleChange}
          />


          <FormControlLabel
            control={
              <Checkbox
                name='renova_automatico'
                id='renova_automatico'
                size='small'
                color="primary"
                onChange={handleChange}
                checked={data.renova_automatico == 'S'}
                disabled={Number(data.dias) <= 240}
              />
            }
            label={'Renova Automático'}
          />

          <FrSelect
            value={data.fk_cvn || ''}
            onChange={handleChange}
            name="fk_cvn"
            id="fk_cvn"
            label='Convênio'
            data={comboCvn}
            style={{ width: 250 }}
          />

          <FormControlLabel
            control={
              <Checkbox
                name='recebeu_carteira'
                id='recebeu_carteira'
                size='small'
                color="primary"
                onChange={handleChange}
                checked={data.recebeu_carteira == 'S'}
              />
            }
            label={'Recebeu Carteira'}
          />

          <br />
          <FrSelect
            value={data.fk_tco || ''}
            onChange={handleChange}
            name="fk_tco"
            id="fk_tco"
            label='Tipo'
            data={comboTco}
            style={{ width: 180 }}
          />
          <FrSelect
            value={data.fk_cam || ''}
            onChange={handleChange}
            name="fk_cam"
            id="fk_cam"
            label='Campanha'
            data={comboCam}
            style={{ width: 200 }}

          />

          <FrSelect
            value={data.fk_sed || ''}
            onChange={handleChange}
            name="fk_sed"
            id="fk_sed"
            label='Unidade'
            data={comboSed}
            style={{ width: 200 }}
          />
          {data.fk_tco == 7 ? <br /> : <></>}
          <FrTextInput
            value={data.pn || ''}
            style={{ width: 80 }}
            name="pn"
            id="pn"
            color="#333333"
            label="PN"
            variant="outlined"
            size="small"
            onChange={handleChange}
            maxLength={10}
            hidden={data.fk_tco != 7}
          />
          <FrTextInput
            value={data.uc || ''}
            style={{ width: 80 }}
            name="uc"
            id="uc"
            color="#333333"
            label="UC"
            variant="outlined"
            size="small"
            onChange={handleChange}
            maxLength={10}
            hidden={data.fk_tco != 7}
          />



          <br />
          <div hidden={data.fk_tpf != 2}>

            <strong>Dados da Conta</strong>

            <button className="botao" onClick={pegaDadosTitular} >
              Replicar Dados Titular
            </button>
            <button className="botao" onClick={pegaDadosResponsavel}>
              Replicar Dados Responsável
            </button>

            <hr width="100%" size="50" color="#083c7c" />
            <br />

            <FrTextInput
              value={data.agencia || ''}
              style={{ width: 100 }}
              name="agencia"
              id="agencia"
              color="#333333"
              label="Agência"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={5}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              value={data.conta || ''}
              style={{ width: 150 }}
              name="conta"
              id="conta"
              color="#333333"
              label="Conta"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={13}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              value={data.nome_titular_conta || ''}
              style={{ width: 400 }}
              name="nome_titular_conta"
              id="nome_titular_conta"
              color="#333333"
              label="Titular Conta"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={100}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              value={mCPF(data.cpf_titular_conta) || ''}
              style={{ width: 150 }}
              name="cpf_titular_conta"
              id="cpf_titular_conta"
              color="#333333"
              label="CPF Titular Conta"
              variant="outlined"
              size="small"
              onChange={handleChange}
              maxLength={20}
              hidden={data.fk_tpf != 2}
            />
            {data.fk_tpf == 2 ? <br /> : <></>}

            <FrTextInput
              maxLength='10'
              value={data.cep_titular_conta ? mCEP(data.cep_titular_conta) : ''}
              onChange={handleChange}
              name="cep_titular_conta"
              id="cep_titular_conta"
              color="#389492"
              label="CEP"
              variant="outlined"
              size="small"
              onBlur={handleCep}
              style={{ width: 110 }}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              maxLength='100'
              value={data.endereco_titular_conta || ''}
              onChange={handleChange}
              name="endereco_titular_conta"
              id="endereco_titular_conta"
              color="#389492"
              label="Endereço"
              variant="outlined"
              size="small"
              style={{ width: 450 }}
              hidden={data.fk_tpf != 2}
            />

            <FrSelect
              value={data.fk_cid_titular_conta || ''}
              onChange={handleChange}
              name="fk_cid_titular_conta"
              id="fk_cid_titular_conta"
              label='Cidade'
              data={comboCid}
              style={{ width: 200 }}
              hidden={data.fk_tpf != 2}
            />

            <FrTextInput
              maxLength='14'
              value={data.fone_titular_conta ? mTel(data.fone_titular_conta) : ''}
              onChange={handleChange}
              name="fone_titular_conta"
              id="fone_titular_conta"
              color="#389492"
              label="Fone Titular Conta"
              variant="outlined"
              size="small"
              style={{ width: 180 }}
              hidden={data.fk_tpf != 2}
            />
          </div>

          <div hidden={data.fk_tpf != 1}>
            <strong>Dados do Cartão</strong>
            <hr width="100%" size="50" color="#083c7c" />
            <br />

            <FrTextInput
              value={data.numero_cartao || ''}
              style={{ width: 150 }}
              name="numero_cartao"
              id="numero_cartao"
              color="#333333"
              label="Nº Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              // onBlur={salvaCartao}
              maxLength={20}
              hidden={data.fk_tpf != 1}
            />
            <FrTextInput
              value={data.cod_seguranca_cartao || ''}
              style={{ width: 90 }}
              name="cod_seguranca_cartao"
              id="cod_seguranca_cartao"
              color="#333333"
              label="CVC"
              variant="outlined"
              size="small"
              onChange={handleChange}
              // onBlur={salvaCartao}
              maxLength={3}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={mValidade(data.venc_cartao) || ''}
              style={{ width: 180 }}
              name="venc_cartao"
              id="venc_cartao"
              color="#333333"
              label="Vcto Cartão (mm/aaaa)"
              variant="outlined"
              size="small"
              onChange={handleChange}
              // onBlur={salvaCartao}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={data.vencimento_fatura_cartao || ''}
              style={{ width: 100 }}
              name="vencimento_fatura_cartao"
              id="vencimento_fatura_cartao"
              color="#333333"
              label="Vcto Fatura"
              variant="outlined"
              size="small"
              onChange={handleChange}
              // onBlur={salvaCartao}
              maxLength={2}
              hidden={data.fk_tpf != 1}
            />

            
            <br />
            <FrTextInput
              value={data.titular_cartao || ''}
              style={{ width: 400 }}
              name="titular_cartao"
              id="titular_cartao"
              color="#333333"
              label="Titular Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              // onBlur={salvaCartao}
              maxLength={100}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={mCPF(data.cpf_titular_cartao) || ''}
              style={{ width: 150 }}
              name="cpf_titular_cartao"
              id="cpf_titular_cartao"
              color="#333333"
              label="CPF Titular Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              // onBlur={salvaCartao}
              maxLength={20}
              hidden={data.fk_tpf != 1}
            />

            <FrTextInput
              value={mTel(data.fone_titular_cartao) || ''}
              style={{ width: 150 }}
              name="fone_titular_cartao"
              id="fone_titular_cartao"
              color="#333333"
              label="Fone Titular Cartão"
              variant="outlined"
              size="small"
              onChange={handleChange}
              // onBlur={salvaCartao}
              maxLength={14}
              hidden={data.fk_tpf != 1}
            />
            <br/>
            <button className="botao" onClick={() => salvaCartao()} type="button">
                Validar/Salvar Cartão
            </button>
          </div>
          <br />
          <div className="defaultHeader">
            <h3>Dependentes</h3>
          </div>

          <div className="xButtons">
            <button className="botao" onClick={incluiDep}> {'Incluir'} </button>
          </div>
          <div>
            <br />

            <div className="tableDiv">
              <FrTableReg rowsPerPage={5} dense editar setDep={setDep} setNome={setNome} setRecebeu_Carteira={setRecebeu_Carteira}
                setCpf={setCpf} setSexo={setSexo} setData_Nascimento={setData_Nascimento} setDataCad={setDataCad}
                setRepresentante={setRepresentante} setFk_Grp={setFk_Grp} setPkModal={setPkModal}
                setModal={setShowModal} setUpdateModal={setUpdateDep}
                setDataGrid={setDataDep} detail regName="contratos" columns={columnsDep} searched={false} codeName="pk" page={''} data={dataDep} />
            </div>

          </div>
          

          <br />
          <div class='row'>

          <div class="column">
            <div class="row" >
              <div class="column" style={{ marginLeft: '15px' }}>
                <label style={{ paddingTop: '5px', width: '120px', textAlign: 'end' }}>Valor Base:</label>
              </div>
              <div class="column" >

                <FrTextInput
                  value={data.mensalidade || ''}
                  style={{ width: 90, marginLeft: '5px' }}
                  name="mensalidade"
                  id="mensalidade"
                  color="#333333"
                  // label="Mensalidade"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  // onBlur={handleBlur}
                  disabled={updateType}
                />
              </div>
            </div>

  
            <div class="row">
              <div class="column" style={{ marginLeft: '15px', width: '120px' }}>
                <label style={{ paddingTop: '5px', width: '120px', textAlign: 'end' }}>Desconto Cliente:</label>
              </div>
              <div class="column">
                <FrTextInput
                  value={onlyNumbers(data.desconto_cliente) || ''}
                  style={{ width: 90, marginLeft: '5px',  backgroundColor: 'silver' }}
                  name="desconto_cliente"
                  id="desconto_cliente"
                  color="#333333"
                  // label="Dia Vcto"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  disabled
                  endAdornment='%'
                />
                
              </div>
              <div class="column">
                <label style={{ paddingTop: '5px' }}>Qtd.Parcelas:</label>
              </div>
              <div class="column">
                <FrTextInput
                  value={data.qtd_desconto_cliente || ''}
                  style={{ width: 50, paddingLeft: '5px' }}
                  name="qtd_desconto_cliente"
                  id="qtd_desconto_cliente"
                  color="#333333"
                  // label="Dia Vcto"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  disabled={updateType}
                />
              </div>
            </div>

            <div class="row">
              <div class="column" style={{ marginLeft: '15px', width: '120px' }}>
                <label style={{ paddingTop: '5px', width: '120px', textAlign: 'end' }}>Desconto Unidade:</label>
              </div>
              <div class="column">
                <FrTextInput
                  value={onlyNumbers(data.desconto_sede) || ''}
                  style={{ width: 90, marginLeft: '5px',  backgroundColor: 'silver' }}
                  name="desconto_sede"
                  id="desconto_sede"
                  color="#333333"
                  // label="Dia Vcto"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  endAdornment='%'
                  disabled
                />
              </div>
              <div class="column">
                <label style={{ paddingTop: '5px' }}>Qtd.Parcelas:</label>
              </div>
              <div class="column">
                <FrTextInput
                  value={data.qtd_desconto_sede || ''}
                  style={{ width: 50, paddingLeft: '5px' }}
                  name="qtd_desconto_sede"
                  id="qtd_desconto_sede"
                  color="#333333"
                  // label="Dia Vcto"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  disabled={updateType}
                />
              </div>
            </div>

            <FrSelect
                  value={data.fk_prm || ''}
                  onChange={handleChange}
                  name="fk_prm"
                  id="fk_prm"
                  label='Promoção'
                  data={comboPrm}
                  style={{ width: 230 ,}}
                />
                <FrTextInput
                  value={data.justificativa_promocao || ''}
                  style={{ width: 300}}
                  name="justificativa_promocao"
                  id="justificativa_promocao"
                  color="#333333"
                  label="Justificativa Promo"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                />

            <div class="row">
              <div class="column" style={{ marginLeft: '15px', width: '120px' }}>
                <label style={{ paddingTop: '5px', width: '120px', textAlign: 'end' }}>Desconto:</label>
              </div>
              <div class="column">
                <FrTextInput
                  value={(data.desconto_outros) || ''}
                  style={{ width: 90, marginLeft: '5px', backgroundColor: 'silver' }}
                  name="desconto_outros"
                  id="desconto_outros"
                  color="#333333"
                  // label="Dia Vcto"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  endAdornment="%"
                  disabled
                />
                
              </div>
              <div class="column">
                <label style={{ paddingTop: '5px' }}>Qtd.Parcelas:</label>
              </div>
              <div class="column">
                <FrTextInput
                  value={data.qtd_desconto_outros || ''}
                  style={{ width: 50, paddingLeft: '5px' }}
                  name="qtd_desconto_outros"
                  id="qtd_desconto_outros"
                  color="#333333"
                  // label="Dia Vcto"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  disabled={updateType}
                />
              </div>
            </div>
            <div class="row" >
              <div class="column" style={{ marginLeft: '15px' }}>
                <label style={{ paddingTop: '5px', width: '120px', textAlign: 'end' }}>Valor Final:</label>
              </div>
              <div class="column" >

                <FrTextInput
                  value={data.valor_final || ''}
                  style={{ width: 90, marginLeft: '5px', backgroundColor: 'silver' }}
                  name="valor_final"
                  id="valor_final"
                  color="#333333"
                  // label="Mensalidade"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  disabled
                />
              </div>
              
            </div>
            
         
            <br/>
              <div  style={{marginLeft: 12}}>

              <FrSelect
                  value={data.fk_fpg || ''}
                  onChange={handleChange}
                  name="fk_fpg"
                  id="fk_fpg"
                  label='Forma de Pagamento'
                  data={comboFpg}
                  style={{ width: 250 }}
                />


                <FrTextInput
                  value={data.dia_venc || ''}
                  style={{ width: 100 }}
                  name="dia_venc"
                  id="dia_venc"
                  color="#333333"
                  label="Dia Vcto"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                />
                <FrSelect
                  value={data.parcelas || ''}
                  onChange={handleChange}
                  name="parcelas"
                  id="parcelas"
                  label='Parcelamento'
                  data={comboParcelas}
                  hidden={!mostraComboParcelas}
                  style={{ width: 300 }}
                />
                

              </div>
            <div className="xxButtons" hidden={updateType}>
              <button className="xbotao" onClick={gerarParcelas}> {'Gerar Parcelas'} </button>
            </div>
            
          </div>
          
          </div>

          <br />
          <div hidden={dataCtr[0].pk == 0}>
            <div className="defaultHeader">
              <h3>Mensalidades</h3>
            </div>

            <div>
              <div className="tableDiv">
                <FrTableReg 
                  startOrder={'asc'} 
                  startOrderBy={'data_venc'} 
                  rowsPerPage={12} 
                  editar={!updateType}
                  setModal={setShowModalCtr} 
                  setPkModal={setPkModal} 
                  setValor={setValor} 
                  setVencimento={setVencimento} 
                  setDataGrid={setDataCtr} 
                  detail 
                  regName="ctrec"
                  columns={columnsCtr} 
                  searched={false} 
                  codeName="pk" 
                  page={''} 
                  data={dataCtr} 
                />
              </div>
            </div>
           
          </div>

          

          <div>
            <Dialog aria-labelledby="simple-dialog-title" open={showModalCtr} fullWidth={true} maxWidth={'lg'}>
              <div className="defaultHeader">
                <h3>{'Edição de parcela'}</h3>
              </div>
              <div className="modalContent">

                <FrDatePicker
                  value={(data_venc || '').split('T')[0]}
                  color="#49573B"
                  label="Dt.Vcto"
                  variant="outlined"
                  size="small"
                  name='data_venc'
                  style={{ width: 130 }}
                  noClear
                  onChange={handleChange}
                />

                <FrTextInput
                  value={valor || ''}
                  style={{ width: 100 }}
                  color="#333333"
                  label="Valor"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  name='valor'
                />

              </div>


              <div className="FrModalFooter">

                <div className="FrModalButtonsDiv">

                  <button onClick={confirmaCtr}> Confirmar</button>
                  <button onClick={escondeModalCtr}> Sair </button>
                </div>
              </div>
            </Dialog>
          </div>

          <div>
            <Dialog aria-labelledby="simple-dialog-title" open={showModal} fullWidth={true} maxWidth={'lg'}>
              <div className="defaultHeader">
                <h3>{titulo}</h3>
              </div>
              <div className="modalContent">
                <AutoComp
                  value={nome || ""}
                  valor={dep}
                  width={425}
                  name="dep"
                  id="dep"
                  label='Dependente'
                  data={comboCli}
                  setValue={setDep}
                  tabela={'clientes'}
                  chave={'nome'}
                  autoFocus
                />
                <button className="buttonF2" style={{ height: '30px', width: '35px', borderRadius: '4px' }} onClick={mostraModalCliente}>
                  <Icon icon={ic_search} size={20} />
                </button>


                <br />
                <FrTextInput
                  value={nome || ''}
                  style={{ width: 425 }}
                  name="nome"
                  id="nome"
                  color="#333333"
                  label="Nome"
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  maxLength={100}
                  disabled
                />

                <FrTextInput
                  value={mCPF(cpf) || ''}
                  style={{ width: 130 }}
                  color="#333333"
                  label="CPF"
                  variant="outlined"
                  size="small"
                  disabled
                />

                <FrTextInput
                  value={sexo || ''}
                  style={{ width: 100 }}
                  color="#333333"
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  disabled
                />

                <FrDatePicker
                  value={(data_nascimento || '').split('T')[0]}
                  color="#49573B"
                  label="Dt.Nascimento"
                  variant="outlined"
                  size="small"
                  style={{ width: 130 }}
                  noClear
                  disabled
                />

                <br />

                <FrSelect
                  value={fk_rep || ''}
                  onChange={handleChange}
                  name="fk_rep"
                  id="fk_rep"
                  label='Representante'
                  data={comboRep}
                  style={{ width: 200 }}
                />

                <FrSelect
                  value={fk_grp || ''}
                  onChange={handleChange}
                  name="fk_grp"
                  id="fk_grp"
                  label='Grau de Parentesco'
                  data={comboGrp}
                  style={{ width: 200 }}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name='dep_recebeu_carteira'
                      id='dep_recebeu_carteira'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={recebeu_carteira == 'S'}
                    />
                  }
                  label={'Recebeu Carteira'}
                />

                <div className="FrModalFooter">

                  <div className="FrModalButtonsDiv">

                    <button onClick={confirmaDep}> Confirmar</button>
                    <button onClick={escondeModal}> Sair </button>
                  </div>
                </div>
              </div>
            </Dialog>
          </div>



          <div>
            <Dialog aria-labelledby="simple-dialog-title" open={showModalCliente} fullWidth={true} maxWidth={'lg'}>
              <Clientes modal setShowModalCliente={setShowModalCliente} setNomeCli={setNomeCli} setPk_Cli={setPk_Cli} />
            </Dialog>
          </div>

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div >
  );
}

export default Contratos;